// extracted by mini-css-extract-plugin
export default {"centerLoader":"Page_centerLoader__M98Nc","placeholderText":"Page_placeholderText__UPOUR","profileCompletionBox":"Page_profileCompletionBox__orQkQ"};